<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions" />
</template>

<script>
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'ExchangeRateManagerList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: [Function, Object],
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'billing_exchange_rates/latest',
        idKey: 'rate',
        responseData: this.responseData,
      }),
      data: [],
      groupActions: [
        {
          label: this.$t('scope.text_661'),
          action: () => {
            this.createDialog('BillExchangeRateCreateDialog', {
              refresh: this.refresh,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
      ],
    }
  },
  created () {
    this.fetchData()
    this.list.fetchData()
  },
  methods: {
    fetchData () {
      new this.$Manager('/billing_exchange_rates/latest').list().then(({ data }) => {
        this.list.responseData = { data }
      })
    },
  },
}
</script>
